import { RequestsByClientTableFiltersActionTypes, RequestsByClientTableFiltersState, SET_REQUESTS_BY_CLIENT_TABLE_FILTERS } from 'store/reducers/lodgingRequest/requests-by-client-table-filters/types';

const defaultState: RequestsByClientTableFiltersState = {
  isLoading: false,
  errorMessage: "",
  contents: { dates: 'FutureDates' },
  exists: false,
};

export default function requestsByClientTableFilters(state = defaultState, action: RequestsByClientTableFiltersActionTypes): RequestsByClientTableFiltersState {
  switch (action.type) {
    case SET_REQUESTS_BY_CLIENT_TABLE_FILTERS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        exists: action.exists,
      };
    default:
      return state;
  }
}
